export default function TermsPage() {
  return (
    <div className="prose prose-sm max-w-none text-text">
      <h1 className="font-display text-2xl font-bold">Terms of Service</h1>
      <p className="text-sm text-text-secondary">Last updated: February 2026</p>

      <h2 className="mt-6 text-lg font-semibold">Acceptance of Terms</h2>
      <p>
        By using ISPYFR, you agree to these terms. If you do not agree, do not
        use the service.
      </p>

      <h2 className="mt-6 text-lg font-semibold">Description of Service</h2>
      <p>
        ISPYFR is a social game platform where players compete in scavenger
        hunts by photographing items and submitting them for review. Games are
        private and invitation-only.
      </p>

      <h2 className="mt-6 text-lg font-semibold">User Conduct</h2>
      <p>You agree not to:</p>
      <ul className="list-disc space-y-1 pl-5">
        <li>Submit photos containing illegal, harmful, or offensive content</li>
        <li>Harass, abuse, or harm other players</li>
        <li>Attempt to interfere with the operation of the service</li>
        <li>Use the service for any unlawful purpose</li>
      </ul>
      <p>
        Game creators are responsible for the games they create and the players
        they invite. ISPYFR is not responsible for content submitted within
        private game sessions.
      </p>

      <h2 className="mt-6 text-lg font-semibold">Content &amp; Photos</h2>
      <p>
        Photos you submit are used solely for gameplay within your game session.
        All photos are automatically deleted after the game&apos;s retention
        period expires. You retain ownership of any photos you submit, but grant
        ISPYFR a temporary license to store and display them for the purpose of
        operating the game.
      </p>

      <h2 className="mt-6 text-lg font-semibold">No Accounts</h2>
      <p>
        ISPYFR does not require user accounts. Your identity within a game is
        limited to the display name you choose when joining. Display names are
        not reserved or unique across games.
      </p>

      <h2 className="mt-6 text-lg font-semibold">Availability</h2>
      <p>
        ISPYFR is provided &ldquo;as is&rdquo; without warranty of any kind. We
        may modify, suspend, or discontinue the service at any time without
        notice.
      </p>

      <h2 className="mt-6 text-lg font-semibold">Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by law, ISPYFR, operated by South Fork
        Mobile LLC, DBA South Fork Games, shall not be liable for any indirect,
        incidental, or consequential damages arising from your use of the
        service.
      </p>

      <h2 className="mt-6 text-lg font-semibold">Changes to These Terms</h2>
      <p>
        We may update these terms from time to time. Continued use of the
        service constitutes acceptance of the updated terms.
      </p>
    </div>
  );
}
